import style from "./Header.module.css";
import logo from "../../assets/images/logo.png";
import { Link, useMatch, useResolvedPath } from "react-router-dom";
import { useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";

function CustomLink({ children, to, ...props }) {
  let resolved = useResolvedPath(to);
  let match = useMatch({ path: resolved.pathname, end: true });

  return (
    <>
      <Link className={`test ${match ? style.active : ""}`} to={to} {...props}>
        {children}
      </Link>
    </>
  );
}
export default function Main() {
  const scrollToAnchor = () => {
    const anchorElement = document.getElementById("search");

    if (anchorElement) {
      anchorElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  let location = useLocation();

  useEffect(() => {
    // console.log("location");
    // console.log(location);
  }, [location]);

  return (
    <>
      <div
        className={`${location.pathname == "/" ? style.type1 : style.type2} ${
          style.header
        } `}
      >
        <div className={style.headerc}>
          <Link to="/">
            <img src={logo} className={`${style.logo}`} />
          </Link>
          <div className={style.nav}>
            <CustomLink to="/">首页</CustomLink>
            <CustomLink to="/about">关于我们</CustomLink>
            <CustomLink to="/recommend">推荐服务</CustomLink>
            <CustomLink to="/company">公司动态</CustomLink>
            <CustomLink to="/industry">行业资讯</CustomLink>
            <a href="https://tzb.release.zgjmdbw.com/" target="_blank">
              保函办理
            </a>
            <a onClick={scrollToAnchor}>保函查询</a>
            <CustomLink to="/contact">联系我们</CustomLink>
          </div>
        </div>
      </div>
      {location.pathname != "/" && <div className={style.headerspan}></div>}
    </>
  );
}
